import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import UserBadgeSash from 'src/sites/kits/People/components/UserBadgeSash'
import { Title } from 'src/sites/kits/UI'

const UserListItemDetailsCard = ({
   avatarMedia,
   avatarSize,
   badges,
   fullName,
   id,
   organization,
   position
}) => {
   const avatarUrl = avatarMedia
      ? avatarMedia?.file.thumbnailUrlW48
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <Link to={`/-/profile/${id}`}>
         <View display="flex" width="100%" style={{ gap: '20px' }}>
            <View
               flex="0 0 auto"
               width={avatarSize}
               height={avatarSize}
               borderRadius="50%"
               backgroundColor="#e8eeee"
               backgroundImage={`url(${avatarUrl})`}
               backgroundSize={avatarMedia ? 'cover' : '80%'}
               backgroundPosition="bottom center"
               style={{ backgroundRepeat: 'no-repeat' }}
            />
            <View
               flex="1 1 auto"
               style={{ width: '100%', overflow: 'hidden' }}>
               <View maxWidth="100%">
                  <Title size="xs" color="#222">
                     {fullName}
                  </Title>
                  {(organization || position) && (
                     <Text
                        color="#888"
                        size="1.5"
                        style={{
                           width: '100%',
                           whiteSpace: 'wrap',
                           wordWrap: 'break-word'
                        }}>
                        <span>{organization}</span>
                        {organization && position && (
                           <span>, </span>
                        )}
                        <span>{position}</span>
                     </Text>
                  )}
                  <UserBadgeSash badges={badges} />
               </View>
            </View>
         </View>
      </Link>
   )
}

UserListItemDetailsCard.propTypes = {
   avatarMedia: PropTypes.object,
   avatarSize: PropTypes.string,
   badges: PropTypes.array,
   fullName: PropTypes.string.isRequired,
   id: PropTypes.string.isRequired,
   organization: PropTypes.string,
   position: PropTypes.string
}

UserListItemDetailsCard.defaultProps = {
   avatarMedia: undefined,
   avatarSize: '30px',
   badges: [],
   organization: undefined,
   position: undefined
}

export default UserListItemDetailsCard
